import { render, staticRenderFns } from "./ParametrizacaoOrcamentoPasso3.vue?vue&type=template&id=41cb2182&lang=html&"
import script from "./ParametrizacaoOrcamentoPasso3.vue?vue&type=script&lang=js&"
export * from "./ParametrizacaoOrcamentoPasso3.vue?vue&type=script&lang=js&"
import style0 from "./ParametrizacaoOrcamentoPasso3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCardTitle,VCheckbox,VCol,VContainer,VForm,VRow,VSelect,VSpacer,VSwitch})
